@if (dot()) {
    <span class="dot" [style.background]="color()"></span>
}
<span class="text"><b [style.color]="colored() ? ink() : null">{{ client() }}</b>{{ rest() }}</span>
